import React from 'react';
import moment from 'moment';
import '../../css/formats.css';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class RefundTicket extends React.Component {


    render() {
        const { DocLines, DocHeader, InfoByFolio, payMethods, reprint, user, time } = this.props
        let totalLetra = '';

        let numeroLetra = new NumeroLetra();
        totalLetra = numeroLetra.NumeroALetras("SOL", Number(Number(DocHeader.DocTotal).toFixed(2)));
        
        return (
            <div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        <div style={{ backgroundColor: 'white', width: "322px", height: "auto", marginLeft: "auto", marginRight: "auto", border: "solid 1px" }}>
                            <div className='row p-2'>
                                <div className='col-12 text-center'>
                                    <span><strong>DEVOLUCIÓN</strong></span>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-12 text-center text-ticket">
                                    <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" style={{ maxWidth: "170px" }} />
                                    <p><strong>{Datos_Empresa.Nombre}<br />{Datos_Empresa.Sociedad}<br /></strong></p>
                                    <p >COL. C.P.;,.</p>
                                    <span >Tel. TEL_{Datos_Empresa.Name} Cel. CEL_{Datos_Empresa.Name}</span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className='col-12 text-ticket '>
                                <label className="text-center" style={{fontSize: "14px"}}>{reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time}</>:""}</label>
                                    <table>
                                        <tbody style={{ borderTop: "solid 2px", borderBottom: "solid 2px" }}>
                                            <tr>
                                                <td>FOLIO: </td>
                                                <td className='text-right' style={{ fontWeight: "bold" }}>{InfoByFolio.folio ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td>FECHA: </td>
                                                <td className='text-right' style={{ fontWeight: "bold" }}>{moment(DocHeader.DocDate).format("YYYY-MM-DD")} {DocHeader.DocTime.toString().substring(0,2)+":"+DocHeader.DocTime.toString().substring(2)}</td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td>Doc. de origen: </td>
                                                <td className='text-right'>ODLN {DocHeader.DocEntry}</td>
                                            </tr>
                                            <tr>
                                                <td>RÉGIMEN FISCAL:</td>
                                                <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                            </tr>
                                            <tr>
                                                <td>Asesor/a de ventas: </td>
                                                <td className='text-right'>{DocHeader.SlpName}</td>
                                            </tr>
                                            <tr>
                                                <td>Cajero/a ID: </td>
                                                <td className='text-right'>{InfoByFolio.userID ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    <div className='text-center pb-3'>
                                        <span><strong>DATOS DEL CLIENTE</strong></span>
                                    </div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>NOMBRE: </td>
                                                <td className='text-right'>{DocHeader.CardName ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td>CLAVE: CA001</td>
                                                <td className='text-right'>RUT: {DocHeader.LicTradNum ?? ''}</td>
                                            </tr>
                                            <tr>
                                                <td>TELÉFONO: </td>
                                                <td className='text-right'>{DocHeader.Cellular ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                </div>
                            </div>
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    <div className='text-center pb-3'>
                                        <span><strong>ARTÍCULOS DEVUELTOS</strong></span>
                                    </div>
                                    <table>
                                        <thead style={{ borderBottom: "solid 2px" }}>
                                            <tr>
                                                <th>Código</th>
                                                <th className='text-right'>Cant.</th>
                                                <th className='text-right'>UM</th>
                                                <th className='text-right'>Precio</th>
                                                <th className='text-right'>Importe</th>
                                                {/* <th className='text-right'>Total</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                                DocLines.map((docline) => {
                                                    return (
                                                        <>
                                                            <tr style={{ fontSize: '11px' }}>
                                                                <td className='text-left' colSpan={6}>{docline.Dscription.substring(0, 45).toUpperCase() ?? ''}</td>
                                                            </tr>
                                                            <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                                <td className='text-right'>{docline.ItemCode ?? ''}</td>
                                                                <td className='text-right'>{FORMAT_NUMBER.new(docline.Quantity) ?? ''}</td>
                                                                <td className='text-right'>UM {''}</td>
                                                                <td className='text-right'>{FORMAT_NUMBER.new(docline.Price) ?? ''}</td>
                                                                {/* <td className="text-center">{docline.Rate.toFixed(2) ?? ''}</td> */}
                                                                <td className='text-right'>{CURRENCY + ' ' + FORMAT_NUMBER.new(docline.LineTotal) ?? ''}</td>
                                                            </tr>
                                                        </>
                                                    );
                                                })
                                            }
                                            <br />
                                            <tr>
                                                <td colspan="1"></td>
                                                <td colspan="2"><strong>SUB TOTAL</strong></td>
                                                <td className='text-right' colspan="2"><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) ?? ''}</strong></td>
                                            </tr>
                                            <tr>
                                                <td colspan="1"></td>
                                                <td colspan="2"><strong>IVA</strong></td>
                                                <td className='text-right' colspan="2"><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td colspan="1"></td>
                                                <td colspan="2"><strong>TOTAL</strong></td>
                                                <td className='text-right' colspan="2"><strong>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</strong></td>
                                            </tr>
                                            <br />
                                            <tr>
                                                <td colspan="5">{totalLetra.toUpperCase()}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br />
                                    <p>Comentarios: Basado en venta de Counter One<br />{InfoByFolio.folio ?? ''}</p>
                                </div>
                            </div>
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    <div className='text-center pb-3'>
                                        <span><strong>{!!payMethods && payMethods.length ? 'REEMBOLSO' : 'REEMBOLSO A CUENTA'}</strong></span>
                                    </div>
                                    <table>
                                        <tbody>
                                            {!!payMethods && payMethods.map((payment) => {
                                                return (
                                                    <tr style={{ fontSize: '11px', marginTop: "-5px !important" }}>
                                                        <td className='text-left'>{payment.pm_Name || ''}</td>
                                                        <td className='text-center'>{payment.paycheckNum || ''}</td>
                                                        <td className='text-center'>{payment.amount ? CURRENCY + ' ' + FORMAT_NUMBER.new(payment.amount) : ''}</td>
                                                    </tr>
                                                );
                                            })}
                                            <br />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row pl-4 pr-4'>
                                <div className='text-center text-ticket-xs'>
                                    <p>
                                        Sin más por el momento y en espera de vernos favorecidos,
                                        quedo de Usted para cualquier duda o aclaración.
                                        * Precios Sujetos a Cambio Sin Previo Aviso.
                                        ** Los precios arriba cotizados son para los volúmenes
                                        solicitados, por lo que al variar estos los precios pueden verse
                                        afectados.<br />
                                        *** Maniobras de descarga a cargo del cliente.
                                        Toda cancelación o devolución sólo será efectiva presentando
                                        la nota y en un plazo no mayor a 7 días.
                                        Si se requiere factura, es en un plazo no mayor a 7 días, y/o
                                        en los casos que aplique, antes de cierre de mes.
                                    </p><br /><br />
                                </div>
                            </div>
                            <div className='row pr-4'>
                                <div className='col-12 text-right pl-4 pr-4 pb-2'>
                                    {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-4'></div>

                </div>

            </div>
        )
    }
}

export default RefundTicket